module.exports = __webpack_public_path__ + "img/bg-caesars-route.36bd0c0d.jpg";